import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {ActivityStatus, CrudStatus, SearchEntities} from '../../../../common/enums';
import {USER_MODULE_NAMESPACE} from '../../../../store/user/user-types.store';
import {IUserDetails} from '../../../../models/user';
import * as moment from "moment";
import {Moment} from "moment";
import {BM_EDIT_MEETING_BY_FIELD, BM_GET_MEETING, BM_MODULE_NAMESPACE} from "../../../../store/building-monitor/bm-types.store";
import {BMMeetingEditedViewModel} from "../../../../models/bm/bm-meeting-edited.viewmodel";
import {IBMMeetingDetailViewModel} from "../../../../models/bm/bm-meeting-detail.viewmodel";
import {DateTimeHelper} from "../../../../utils/DateTimeHelper.util";

const UserStore = namespace(USER_MODULE_NAMESPACE);
const BMStore = namespace(BM_MODULE_NAMESPACE)

@Component({
  components: {
    'bm-ib_avatar': async () => import('../../components/bm-ib-avatar-widget/BMIBAvatarWidget.vue'),
  }
})
class TicketModalVertical extends Vue {

  private dtStep: number;
  meetingStartDate: string
  meetingEndDate: string
  meetingNextDate: string
  coCreateFromPrevious: boolean

  constructor() {
    super();
    this.dtStep = 15
    this.meetingStartDate = moment().format('YYYY-MM-DDTHH:mm:ss').substring(0, 14)+'00:00'
    this.meetingEndDate = moment().format('YYYY-MM-DDTHH:mm:ss').substring(0, 14)+'15:00'
    this.coCreateFromPrevious = false
  }

  @UserStore.Getter userInfo: IUserDetails;
  @BMStore.Getter bmMeetingEdited: BMMeetingEditedViewModel;
  @BMStore.Getter bmMeeting: { activityStatus: ActivityStatus; data: IBMMeetingDetailViewModel };
  @BMStore.Getter bmMeetings: {
    activityStatus: ActivityStatus,
    data: any[]
  };
  @BMStore.Getter bmCrudActionStatus: CrudStatus

  @BMStore.Mutation(BM_EDIT_MEETING_BY_FIELD)
  storeSetMeetingEdited: (payload: { [key: string]: any }) => void

  @BMStore.Action(BM_GET_MEETING)
  storeGetMeeting: (payload: { bmId: string, idm: string }) => Promise<any>

  get coLastMeetingId(): number {
    return this.bmMeetingEdited.lastMeetingId
  }
  set coLastMeetingId(value: number) {
    this.storeSetMeetingEdited({
      lastMeetingId: value
    })
    if (value) {
      if (this.bmMeeting.data && this.bmMeeting.data.id === value) {
        // no changes
      } else {
        this.storeGetMeeting({bmId: this.$route.params.id, idm: value.toString()})
          .then(response => {
            if (response.date_next_meeting) {
              this.coDates = {
                startDate: response.date_next_meeting,
                endDate: moment(response.date_next_meeting).add(1, 'hours').toISOString()
              }
            }
          })
      }
    }
  }

  get coSendNextMeeting(): boolean {
    return this.bmMeetingEdited.sendNextMeeting
  }

  set coSendNextMeeting(value) {
    this.storeSetMeetingEdited({
      sendNextMeeting: value
    })
  }

  get coDates() {
    return {
      startDate: this.bmMeetingEdited.date_start,
      endDate: this.bmMeetingEdited.date_end
    }
  }
  set coDates(dates: { startDate: string | Date | Moment, endDate: string | Date | Moment }) {
    this.meetingStartDate = dates.startDate.toString();
    this.meetingEndDate = dates.endDate.toString();
    this.storeSetMeetingEdited({
      date_start: dates.startDate.toString(),
      date_end: dates.endDate.toString(),
    })
  }
  get coDatesNextMeeting() {
    return {
      startDate: this.bmMeetingEdited.date_next_meeting
    }
  }
  set coDatesNextMeeting(dates: { startDate: string | Date | Moment }) {
    this.meetingNextDate = dates.startDate.toString();
    this.storeSetMeetingEdited({
      date_next_meeting: dates.startDate.toString(),
    })
  }

  get lblSetting() {
    return {
      ...require('@/locales/agenda').default,
      ...require('@/locales/building-monitor').default,
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/generic-labels').default,
    }
  }

  get isUpdate () {
    return this.bmCrudActionStatus === CrudStatus.Update
  }

  get nextMeetingDisabled() {
    return !this.coSendNextMeeting
  }

  get meetingList() {
    return (this.bmMeetings.data || []).map(x => {
      x.name = this.$t(this.lblSetting.bmMeetingName, {date: DateTimeHelper.parseDate(x.date_start)})
      return x
    }).filter(x => x.state === 'close')
  }

  created() {}

  mounted() {
  }

  changeSwitchCreateFromPreviousMeeting (val) {
    if (val) {
      this.coLastMeetingId = this.meetingList[0].id
    } else {
      this.coLastMeetingId = null
    }
  }

  avatarLink(item) {
    if (item.avatar && item.avatar.link)
      return item.avatar.link
    return null
  }

  avatarText(item): string {
    return `${(item.firstname || '').substring(0, 1)}${(item.lastname || '').substring(0, 1)}`;
  }
}

export default TicketModalVertical;



// WEBPACK FOOTER //
// ./src/containers/building-monitor/components/bm-meeting-modal-vertical/index.ts